/**
 * Tenant URL helpers (shared by Login and Power User Dashboard).
 */

/**
 * Returns the base domain (e.g. simplyinventory.co.uk) from a hostname.
 * - www.simplyinventory.co.uk → simplyinventory.co.uk
 * - simplyinventory.co.uk → simplyinventory.co.uk
 * - hanagroup.simplyinventory.co.uk → simplyinventory.co.uk (first label is tenant subdomain)
 */
export function getBaseDomainFromHost(hostname) {
  if (!hostname || typeof hostname !== "string") return hostname || "";
  let h = hostname.toLowerCase().trim();
  if (h.startsWith("www.")) h = h.slice(4);
  const parts = h.split(".");
  // Only treat first label as subdomain when there are 4+ parts (e.g. hanagroup.simplyinventory.co.uk).
  // For 3 parts (e.g. simplyinventory.co.uk) this is the apex, not subdomain.
  if (parts.length >= 4) return parts.slice(1).join(".");
  return h;
}

export function makeTenantUrl(subdomain, locationLike) {
  if (!subdomain) return "";
  const loc = locationLike != null ? locationLike : (typeof window !== "undefined" ? window.location : null);
  if (!loc) return "";
  const protocol = loc.protocol || "https:";
  const hostname = loc.hostname || "";
  const base = getBaseDomainFromHost(hostname);
  const port = loc.port || "";
  const isLocalhost = base === "localhost" || base.startsWith("127.");
  if (isLocalhost) {
    const portPart = port ? ":" + port : "";
    return protocol + "//" + subdomain + ".localhost" + portPart;
  }
  return protocol + "//" + subdomain + "." + base;
}

/**
 * Returns the root URL (no subdomain) for the current host, e.g. https://simplyinventory.co.uk
 */
export function getRootUrl(locationLike) {
  const loc = locationLike != null ? locationLike : (typeof window !== "undefined" ? window.location : null);
  if (!loc) return "";
  const protocol = loc.protocol || "https:";
  const base = getBaseDomainFromHost(loc.hostname || "");
  const port = loc.port || "";
  const isLocalhost = base === "localhost" || base.startsWith("127.");
  const portPart = isLocalhost && port ? ":" + port : "";
  return protocol + "//" + base + portPart;
}
